export const extractErrorMessage = (error: unknown): string => {
  const detail = (error as { detail?: unknown } | null)?.detail;
  if (typeof detail === "string") {
    return detail;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Please try again.";
};
